const getCustomPalettesToCreate = (initialCustomPalettes, currentCustomPalettes) => {
  const initialCustomPalettesIdsSet = new Set(initialCustomPalettes.map((p) => p.id));
  return currentCustomPalettes.filter((palette) => !initialCustomPalettesIdsSet.has(palette.id));
};

export default getCustomPalettesToCreate;
